import $ from 'jquery';
import processor from './processors';

$(function () {
    $(document).on('click', ':submit', function (e) {
        var $this = $(this);
        $this.closest('form').data('submitter', {
            name: $this.attr('name'),
            value: $this.val()
        });
    });

    $(document).on('submit', 'form', function (e) {
        let frm = $(this);
        if (!frm.attr('data-ajax-non-blocking')) {
            $('body').attr('data-ajax-busy', true)
        }
        var beforeSubmitEvent = $.Event('before_submit');
        frm.trigger(beforeSubmitEvent);
        if (beforeSubmitEvent.isPropagationStopped()) {
            e.stopPropagation();
        }
        if (beforeSubmitEvent.isImmediatePropagationStopped()) {
            e.stopImmediatePropagation();
        }
        if (beforeSubmitEvent.isDefaultPrevented()) {
            e.preventDefault();
        }

        if (!beforeSubmitEvent.isPropagationStopped() && !beforeSubmitEvent.isImmediatePropagationStopped() && !beforeSubmitEvent.isDefaultPrevented()) {
            var ajaxSubmitEvent = $.Event('ajax_submit');
            ajaxSubmitEvent.deferred = e.deferred;
            frm.trigger(ajaxSubmitEvent);
            if (ajaxSubmitEvent.isPropagationStopped()) {
                e.stopPropagation();
            }
            if (ajaxSubmitEvent.isImmediatePropagationStopped()) {
                e.stopImmediatePropagation();
            }
            if (ajaxSubmitEvent.isDefaultPrevented()) {
                e.preventDefault();
            }
        }
    });

    $(document).on('ajax_submit', 'form[data-ajax]', function (e) {
        var $this = $(this),
            formData = $this.serializeArray();

        if ($this.data('submitter')) {
            formData.push($this.data('submitter'));
        }

        $.ajax({
            url: $this.attr('data-ajax'),
            type: $this.attr('method'),
            data: formData,
            success: function (data, status, xhr) {
                let away = false;
                if (data && typeof data === 'object') {
                    if (data.replace) {
                        var container = $this.parent().hasClass('ajax-response') ? $this.parent() : $this,
                            replacement = $(data.replace);
                        container.replaceWith(replacement);
                    }

                    if (data.redirect) {
                        away = true;
                        window.location = data.redirect;
                    }
                } else {
                    var container = $this.parent().hasClass('ajax-response') ? $this.parent() : $this,
                        isModal = container.parents('.modal').length,
                        replacement = $(data);

                    container.replaceWith(replacement);
                    processor.run(replacement);
                }

                if (!away) {
                    if (!$this.attr('data-ajax-non-blocking')) {
                        $('body').removeAttr('data-ajax-busy');
                    }
                    if ($this.attr('data-ajax').indexOf('#') !== -1) {
                        // This is the best way to empty and replace the hash
                        history.replaceState({}, document.title, window.location.href.split('#')[0]);
                        $(window).trigger('hashchange');
                        history.replaceState({}, document.title, window.location.href.split('#')[0] + $this.attr('data-ajax').substring($this.attr('data-ajax').indexOf('#')));
                        $(window).trigger('hashchange');
                    }
                }
                
                $this.trigger('ajax_done');

                if (e.deferred) {
                    e.deferred.resolve($this);
                }
            },
            headers: {
                'Ajax-Request': 'yes'
            },
            error: function (xhr, status, error) {
                var errortext = $this.find('.errortext');
                if (!errortext.length) {
                    errortext = $('<div class="alert alert-primary alert-dismissible fade show"><span><\/span><button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">×<\/span><\/button><\/div>').prependTo($this);
                }
                errortext.find('span:first').text('Sorry, something went wrong. Please try again.').show();

                if (!$this.attr('data-ajax-non-blocking')) {
                    $('body').removeAttr('data-ajax-busy');
                }
                $this.trigger('ajax_done');
                if (e.deferred) {
                    e.deferred.reject($this);
                }
            }
        });
        e.preventDefault();
        return false;
    });

    $(document).on('click', 'a[data-submit-forms]', function (e) {
        e.preventDefault();

        let a = $(this),
            forms = $(a.attr('data-submit-forms')),
            deferreds = [];

        $('body').attr('data-ajax-busy-multiple', true);

        forms.each(function () {
            let e = $.Event('submit');
            e.deferred = $.Deferred();
            $(this).trigger(e);
            deferreds.push(e.deferred.promise());
        });

        $.when.apply(this, deferreds).then(function () {
            if (a.attr('href') !== '#') {
                if (window.loadlink) {
                    window.loadlink(a.attr('href'));
                }
                else {
                    window.location = a.attr('href');
                }
            }
            $('body').removeAttr('data-ajax-busy-multiple');
        }, function () {
            $('body').removeAttr('data-ajax-busy-multiple');
        });
    });

    $(document).on('change', ':input[data-submit-on-change]', function (e) {
        $(this).closest('form[data-ajax]').trigger('submit');
    })
});